import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { useCallback, useEffect, useState } from "react";
import { ApiBaseUrl } from "../../http";
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { INotification, NotificationFormData } from "./notification.type";
import { usePagination } from "../../hooks";
import { QueryUrl } from "../../utils";
import { useAppSelector } from "../../../redux/hooks";

export const NotificationApi = createApi({
	reducerPath: "notificationApi",
	tagTypes: ["notification"],
	baseQuery: fetchBaseQuery({
		baseUrl: `${ApiBaseUrl}/api/`,
		prepareHeaders,
	}),
	endpoints: (builder) => ({
		getNotifByUser: builder.query<
			PaginationResults<INotification> | INotification[],
			TypeQuery
		>({
			query: ({ slug, ...query }) => QueryUrl(`user/${slug}/notifications`, query),
			providesTags: ["notification"],
		}),
		readNotification: builder.mutation<INotification, NotificationFormData>({
			query: ({ slug, ...data }) => ({
				url: `notifications/${slug}/`,
				body: data,
				method: "PUT",
			}),
			invalidatesTags: ["notification"],
		}),
		deleteNotification: builder.mutation<INotification, NotificationFormData>({
			query: (slug) => ({
				url: `notifications/${slug}/`,
				method: "DELETE",
			}),
			invalidatesTags: ["notification"],
		}),
	}),
});

export const {
	useLazyGetNotifByUserQuery,
	useReadNotificationMutation,
	useGetNotifByUserQuery,
	useDeleteNotificationMutation,
} = NotificationApi;

export function useNotification() {
	const { user } = useAppSelector((s) => s?.user);
	const { page, setPage, limit, setPerPage } = usePagination(20);
	const [count, setCount] = useState(0);
	const { data, isLoading } = useGetNotifByUserQuery(
		{ page, limit, slug: user?.slug },
		{ skip: !user?.slug }
	);
	const [readMessage] = useReadNotificationMutation();

	const notificationList: INotification[] = Array.isArray(data)
		? data
		: data?.results || [];

	const totalCount: number = Array.isArray(data)
		? data.length
		: data?.count || 0;

	const functionCountunreadNotif = useCallback(() => {
		let count = 0;
		notificationList?.forEach((notif) => {
			if (!notif?.read) {
				count++;
			}
		});
		setCount(count);
	}, [notificationList]);

	useEffect(() => {
		functionCountunreadNotif();
	}, [functionCountunreadNotif]);

	const readAll = () => {
		notificationList?.forEach((item) => {
			readMessage({ slug: item?.slug, read: true });
		});
	};
	const readNotif = (slug: string) => {
		console.log("call");
		return readMessage({ slug: slug, read: true });
	};

	return {
		count,
		data: notificationList,
		isLoading,
		readAll,
		readNotif,
		notifications: notificationList?.filter((item) => !item?.read),
		page,
		limit,
		setPage,
		setPerPage,
		total: totalCount,
	};
}
